import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { getToken } from 'selectors/auth'
import env from 'config/env'
import { logout } from 'actions/auth'

/**
 * Axios client configured with interceptors
 * - Automatically adds Authorization header with JWT token
 * - Handles 401 errors by redirecting to login
 */

const apiClient: AxiosInstance = axios.create({
  baseURL: env.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

/**
 * Request interceptor
 * Add Authorization header with token to every request
 */
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken()

    if (token && config.headers) {
      config.headers.Authorization = token
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

/**
 * Response interceptor
 * Handle 401 errors by redirecting to login page
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      logout()
    }
    return Promise.reject(error)
  },
)

export default apiClient
